import React from "react";
import ReactApexChart from "react-apexcharts";
import { Box, Typography } from "@mui/material";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";

export default function PrettyDonut({ data, simplified = false }) {
  const notExec = data.totalCount - (data.passCount + data.failCount);
  const seriesNames = ["Pass", "Fail", "Not Executed", "Skipped Over"];
  const passPercent =
    data.totalCount > 0 ? ((data.passCount / data.totalCount) * 100).toFixed(1) : "0.0";
  const failPercent =
    data.totalCount > 0 ? ((data.failCount / data.totalCount) * 100).toFixed(1) : "0.0";
  const series = simplified
    ? [data.passCount, data.failCount]
    : [data.passCount, data.failCount, notExec, data?.skippedOver || 0];

  const options = {
    chart: {
      type: "donut",
      animations: { enabled: false },
      height: 350,
    },
    dataLabels: {
      enabled: false,
    },
    colors: simplified
      ? ["#008000", "#FF4C4C"]
      : ["#008000", "#FF4C4C", "#835FF0", "#D6DEF8", "#FFC107"],
    labels: simplified ? ["Pass", "Fail"] : seriesNames,
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 200,
          },
          legend: {
            show: false,
          },
        },
      },
    ],
    legend: simplified
      ? { show: false }
      : {
          position: "bottom",
          offsetY: 0,
          horizontalAlign: "center",
          fontSize: "12px",
          itemMargin: { horizontal: 5, vertical: 2 },
          formatter: (seriesName, opts) => {
            if (!data.totalCount || data.totalCount === 0) return `${seriesName}: 0%`;
            const percentage = (
              (opts.w.globals.series[opts.seriesIndex] / data.totalCount) *
              100
            ).toFixed(1);
            return `${seriesName}: ${percentage}%`;
          },
        },
    plotOptions: {
      pie: {
        donut: {
          size: "65%",
        },
      },
    },
  };

  return (
    <Box
      sx={{
        bgcolor: "#fff",
        height: "100%",
        borderRadius: "8px",
        padding: "16px",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Typography
        sx={{
          color: "#232D3D",
          fontSize: "16px",
          fontWeight: 600,
          textAlign: "center",
          marginBottom: "8px",
        }}
      >
        Test Case Results
      </Typography>
      {simplified ? (
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
          <Box sx={{ width: "200px", minHeight: "200px" }}>
            <ReactApexChart
              options={options}
              series={series}
              type="donut"
              height="200px"
              width="200px"
            />
          </Box>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 2, ml: 2 }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <ArrowUpwardIcon sx={{ color: "#008000", fontSize: "28px" }} />
              <Box>
                <Typography sx={{ fontSize: "22px", fontWeight: 700, color: "#008000" }}>
                  {passPercent}%
                </Typography>
                <Typography sx={{ fontSize: "12px", color: "#8089A8" }}>Pass</Typography>
              </Box>
            </Box>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <ArrowDownwardIcon sx={{ color: "#FF4C4C", fontSize: "28px" }} />
              <Box>
                <Typography sx={{ fontSize: "22px", fontWeight: 700, color: "#FF4C4C" }}>
                  {failPercent}%
                </Typography>
                <Typography sx={{ fontSize: "12px", color: "#8089A8" }}>Fail</Typography>
              </Box>
            </Box>
          </Box>
        </Box>
      ) : (
        <Box sx={{ flex: 1, minHeight: "300px" }}>
          <ReactApexChart
            options={options}
            series={series}
            type="donut"
            height="100%"
            width="100%"
          />
        </Box>
      )}
    </Box>
  );
}
